module.exports = __webpack_public_path__ + "img/http.d1df14cb.svg";